import { CommonDialogProps, DialogConfig } from '../common/types'
import { WatchWalletDialogContentContainer } from './WatchWalletDialogContentContainer'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { testIds } from '@/ui/utils/testIds'

export type WatchWalletDialogProps = { asDrawer?: boolean } & CommonDialogProps

function WatchWalletDialog({ open, setOpen, asDrawer = false }: WatchWalletDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        contentVerticalPosition={asDrawer ? 'bottom' : 'center'}
        data-testid={testIds.dialog.watchWallet.dialog}
      >
        <WatchWalletDialogContentContainer closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const watchWalletDialogConfig: DialogConfig<WatchWalletDialogProps> = {
  options: {
    closeOnAccountChange: false,
  },
  element: WatchWalletDialog,
  name: 'WatchWalletDialog',
}
